const Order = {
  id: 'OrderSchema',
  type: 'object',
  required: [
    'orderCustomerName',
    'orderCustomerSocialName',
    'orderCustomerPhone',
    'orderCustomerEmail',
    'orderCustomerAddress',
    'orderCustomerPostal',
    'orderPaymentType',
    'orderShippingPrice',
    'orderServiceCharge',
    'orderTotal'
  ],
  properties: {
    orderCustomerName: {
      type: 'string',
      minLength: 3,
      maxLength: 150
    },
    orderCustomerSocialName: {
      type: 'string',
      minLength: 3,
      maxLength: 150
    },
    orderCustomerPhone: {
      type: 'string',
      minLength: 9,
      maxLength: 11,
      pattern: '^[0].*'
    },
    orderCustomerEmail: {
      type: 'string',
      pattern: '[a-zA-Z0-9_\\.\\+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-\\.]+'
    },
    orderCustomerAddress: {
      type: 'string',
      minLength: 3,
      maxLength: 150
    },
    orderCustomerPostal: {
      type: 'string',
      minLength: 5,
      maxLength: 5
    },
    orderPaymentType: {
      type: 'string'
    },
    orderVerifyPayment: {
      type: 'boolean'
    },
    orderPaymentSelectedBank: {
      type: 'string'
    },
    orderPaymentDate: {
      type: 'string'
    },
    orderPaymentImage: {
      type: 'string'
    },
    orderVerifyCOD: {
      type: 'boolean'
    },
    orderPaymentCOD: {
      type: 'string'
    },
    orderShippingPrice: {
      type: 'number'
    },
    orderServiceCharge: {
      type: 'number'
    },
    orderTotal: {
      type: 'number'
    }
  }
};

export default Order;
